/**
 *
 * @module component/helpers
 * @author Adam Pirani [adam.pirani@mlb.com]
 * @description module for adding handlebars helpers
 *
 */

let _i18n;

/**
 *
 * @function setupDictionary
 * @description sets up the dictionary key/value reference
 *
 */
(function setupDictionary() {

    global.i18n_dictionary = global.i18n_dictionary || {};

    class i18nClient {

        constructor(dictionary) {
            this.dictionary = dictionary;
        }

        __(key, fallBackText) {
            return this.dictionary[key] ? this.dictionary[key] : (fallBackText || '');
        }
    }

    _i18n = new i18nClient(global.i18n_dictionary);

}());

/**
 *
 * @name helpers
 * @description handlebars helpers to be registered
 *
 */
let helpers = {
    /**
     *
     * @function ifOr
     * @param {Boolean} a
     * @param {Boolean} b
     * @param {Object} options
     * @returns {Function}
     *
     */
    ifOr: function (a, b, options) {

        if (a || b) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }

    },
    /**
     *
     * @function ifAnd
     * @param {Boolean} a
     * @param {Boolean} b
     * @param {Object} options
     * @returns {Function}
     *
     */
    ifAnd: function (a, b, options) {

        if (a && b) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }

    },
    /**
     *
     * @function withItem
     * @description access object value with a variable key
     * @param {Object} obj
     * @param {Object} options
     * @returns {Function}
     *
     */
    withItem: function (obj, options) {

        return options.fn(obj[options.hash.key]);

    },

    /**
     *
     * @function concat
     * @description Concatenate all strings input into the helper
     * @param {Array} vals
     * @returns {String}
     *
     */
    concat: function (...vals) {

        vals.pop();

        return vals.join('');
    },
    /**
     *
     * @function i18n
     * @description localization dict reference
     * @param {String} key
     * @param {String} fallBackText
     * @returns {String}
     *
     */
    i18n: function (key, fallBackText) {

        return _i18n.__(key, fallBackText);

    },

    /** Checks for strict equality, provides `else` support
     * @note imported from https://github.mlbam.net/fed-basesite/bam-handlebars-helpers/
     * @param one
     * @param two
     * @param options
     * @returns {*}
     */
    equals: function (one, two, options) {
        //{{equals one two}} {{else}} {{/equals}}
        if (one === two) {
            return options.fn(this);
        }
        return options.inverse(this);
    },

    /** Checks for if the first param is less than the second param
     * @param one
     * @param two
     * @param options
     * @returns {*}
     */
    isLess: function (one, two, options) {
        //{{isLess 1 2}} {{else}} {{/isLess}}
        if (one && one < two) {
            return options.fn(this);
        }
        return options.inverse(this);
    },

    /** stringify an object to json format
     * @note imported from https://github.mlbam.net/fed-basesite/bam-handlebars-helpers/
     * @param options
     * @returns {*}
     */
    json: function (opts) {
        return JSON.stringify(opts);
    },

    /** truncate a string and add ellipsis
     * @param text
     * @param maxLength
     * @returns {String}
     */
    truncate: function (text, maxLength) {

        if (text.length < maxLength) {
            return text;
        } else {
            const shortText = text.substr(0, maxLength);
            const words = shortText.split(' ');
            let truncated = words.slice(0, (words.length - 1));
            truncated = truncated.join(' ');
            return `${truncated}...`;
        }
    }

};

export default helpers;
